var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F66A3D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1447_478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.333,
    y: 16,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1447_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.333 34C25.783 34 25.3122 33.8042 24.9205 33.4125C24.5288 33.0208 24.333 32.55 24.333 32V30.75C23.383 30.1 22.6455 29.2667 22.1205 28.25C21.5955 27.2333 21.333 26.15 21.333 25C21.333 23.05 22.0122 21.3958 23.3705 20.0375C24.7288 18.6792 26.383 18 28.333 18C30.283 18 31.9372 18.6792 33.2955 20.0375C34.6538 21.3958 35.333 23.05 35.333 25C35.333 26.15 35.0705 27.2292 34.5455 28.2375C34.0205 29.2458 33.283 30.0833 32.333 30.75V32C32.333 32.55 32.1372 33.0208 31.7455 33.4125C31.3538 33.8042 30.883 34 30.333 34H26.333ZM26.333 32H30.333V29.7L31.183 29.1C31.8663 28.6333 32.3955 28.0375 32.7705 27.3125C33.1455 26.5875 33.333 25.8167 33.333 25C33.333 23.6167 32.8455 22.4375 31.8705 21.4625C30.8955 20.4875 29.7163 20 28.333 20C26.9497 20 25.7705 20.4875 24.7955 21.4625C23.8205 22.4375 23.333 23.6167 23.333 25C23.333 25.8167 23.5205 26.5875 23.8955 27.3125C24.2705 28.0375 24.7997 28.6333 25.483 29.1L26.333 29.7V32ZM26.333 38C26.0497 38 25.8122 37.9042 25.6205 37.7125C25.4288 37.5208 25.333 37.2833 25.333 37V36H31.333V37C31.333 37.2833 31.2372 37.5208 31.0455 37.7125C30.8538 37.9042 30.6163 38 30.333 38H26.333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicPresentation);
export default __webpack_public_path__ + "static/media/dynamic_presentation.2116c7bbb63b29421a264cd9ec466819.svg";
export { ForwardRef as ReactComponent };